// extracted by mini-css-extract-plugin
export default {"StoryThumb":"Oci87","gridThumbnail":"p2n1I","listThumbnail":"Omtrn","cardThumbnail":"aoD8o"};